export function formatNumber(num, decimals, decimal_separator, thousands_separator) {
    if (decimals === void 0) { decimals = 2; }
    if (decimal_separator === void 0) { decimal_separator = '.'; }
    if (thousands_separator === void 0) { thousands_separator = ','; }
    return num.toFixed(decimals).replace('.', decimal_separator).replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator);
}
export function appendLinkElement(href, options) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    if (options) {
        for (var _i = 0, _a = Object.entries(options); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            link.setAttribute(key, value);
        }
    }
    document.head.appendChild(link);
}
//# sourceMappingURL=index.js.map